export class AuthModel {
  id: string;
  accessToken: string;
  refreshToken: string;
  expiresIn: Date;
  role: number;
  primarygroupsid: number;
  primarysid: number;

  setAuth(auth: any) {
    this.id = auth.accessToken;
    this.accessToken = auth.accessToken;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
    this.role = auth.role;
    this.primarygroupsid = auth.primarygroupsid;
    this.primarysid = auth.primarysid;
  }
}



export class PassChange {
  Success: boolean;
  Mensaje: string;
  Codigo: string;
}